export default __webpack_public_path__ + "static/media/plan-a-media-group-plan-a-live-2.5ef9877a.png";